import {ThemeProvider} from "@mui/material";
// import { LicenseInfo } from "@mui/x-license";
import {AuthProvider} from "react-oidc-context";
import {Navigate, Route, BrowserRouter as Router, Routes} from "react-router-dom";
import OidcCallback from "./components/Auth/OidcCallback";
import ProtectedRoute from "./components/ProtectedRoute";
import {oidcConfig} from "./config/oidcConfig";
import MainLayout from "./layouts/MainLayout";
import Acceso from "./pages/Acceso/Acceso";
import ClientDetail from "./pages/ClientDetail";
import Clients from "./pages/Clients";
import Dashboard from "./pages/Dashboard";
import M2MTokens from "./pages/M2MTokens";
import M2MTokenDetail from "./pages/M2MTokenDetail";
import RoleDetail from "./pages/RoleDetail";
import Roles from "./pages/Roles";
import ScopeDetail from "./pages/ScopeDetail";
import Scopes from "./pages/Scopes";
import Tokens from "./pages/Tokens";
import UserDetail from "./pages/UserDetail";
import Users from "./pages/Users";
import {darkTheme, lightTheme} from "./styles/theme";
import ProtectedLayout from "./layouts/ProtectedLayout";
import {useThemeStore} from "./stores/useThemeStore";
import {SnackbarProvider} from "notistack";
import {useAuth} from "react-oidc-context";
import {injectAuth} from "./utils/apiClient";
import {useEffect} from "react";
import SnackbarCopy from "./components/Notifications/SnackbarCopy";

function App() {
  const AUTH_ALLOWED_ROLES = process.env.REACT_APP_AUTH_ALLOWED_ROLES.split(",");
  // Comentamos la configuración de licencia para usar la versión community
  // const LICENSE_KEY = process.env.REACT_APP_DATAGRID_PRO_LICENSE_KEY;
  // LicenseInfo.setLicenseKey(LICENSE_KEY);

  const {mode} = useThemeStore();

  return (
    <AuthProvider {...oidcConfig}>
      <AuthInjector>
        <ThemeProvider theme={mode === "dark" ? darkTheme : lightTheme}>
          <SnackbarProvider
            maxSnack={3}
            anchorOrigin={{vertical: "top", horizontal: "right"}}
            style={{zIndex: 99999}}
            Components={{
              copy: SnackbarCopy
            }}
          >
            <Router>
              <Routes>
                {/* Rutas de OpenID Connect - deben estar fuera del layout */}
                <Route path="/callback" element={<OidcCallback />} />

                {/* Ruta de acceso */}
                <Route path="/acceso" element={<Acceso />} />

                {/* ZONA PROTEGIDA */}
                <Route element={<ProtectedLayout roles={AUTH_ALLOWED_ROLES} />}>
                  <Route path="/" element={<MainLayout />}>
                    {/* Ruta por defecto */}
                    <Route index element={<Navigate to="/dashboard" replace />} />
                    <Route path="login" element={<Navigate to="/dashboard" replace />} />

                    {/* Rutas protegidas */}
                    <Route
                      path="dashboard"
                      element={
                        <ProtectedRoute roles={["AUTH.Admin", "AUTH.User"]}>
                          <Dashboard />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="users"
                      element={
                        <ProtectedRoute roles={["AUTH.Admin"]}>
                          <Users />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="roles"
                      element={
                        <ProtectedRoute roles={["AUTH.Admin"]}>
                          <Roles />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="role-form"
                      element={
                        <ProtectedRoute roles={["AUTH.Admin"]}>
                          <RoleDetail />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="user-form"
                      element={
                        <ProtectedRoute roles={["AUTH.Admin"]}>
                          <UserDetail />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="scope-form"
                      element={
                        <ProtectedRoute roles={["AUTH.Admin"]}>
                          <ScopeDetail />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="scopes"
                      element={
                        <ProtectedRoute roles={["AUTH.Admin"]}>
                          <Scopes />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/clients"
                      element={
                        <ProtectedRoute roles={["AUTH.Admin"]}>
                          <Clients />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="client-form"
                      element={
                        <ProtectedRoute roles={["AUTH.Admin"]}>
                          <ClientDetail />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/tokens"
                      element={
                        <ProtectedRoute roles={["AUTH.Admin"]}>
                          <Tokens />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/m2m-tokens"
                      element={
                        <ProtectedRoute roles={["AUTH.Admin"]}>
                          <M2MTokens />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="m2m-tokens-form"
                      element={
                        <ProtectedRoute roles={["AUTH.Admin"]}>
                          <M2MTokenDetail />
                        </ProtectedRoute>
                      }
                    />
                  </Route>
                </Route>
                <Route path="*" element={<Navigate to="/acceso" replace />} />
              </Routes>
            </Router>
          </SnackbarProvider>
        </ThemeProvider>
      </AuthInjector>
    </AuthProvider>
  );
}

function AuthInjector({children}) {
  const auth = useAuth();

  useEffect(() => {
    injectAuth(auth);
  }, [auth]);

  return children;
}

export default App;
